import React from 'react';
import * as reactUtils from '../../packages/react-utils/react-utils.js';
import '@flixbus/honeycomb-icons-react';
import '../../packages/props-utils/prop-types.js';

const panelChildrenValidator = () => _ref => {
  let {
    children
  } = _ref;
  if (children == null) {
    return new Error('\'children\' is required for \'Panel\'.');
  }
  const panelChildrenArr = React.Children.toArray(children);
  const panelHeader = panelChildrenArr.filter(child => {
    const childName = child && reactUtils.getElementName(child);
    return childName === 'PanelHeader';
  });
  if (panelHeader.length === 0) {
    return new Error('\'PanelHeader\' is required as a \'Panel\' child.');
  }
  const panelContent = panelChildrenArr.filter(child => {
    const childName = child && reactUtils.getElementName(child);
    return childName === 'PanelContent';
  });
  if (panelContent.length === 0) {
    return new Error('\'PanelContent\' is required as a \'Panel\' child.');
  }
  return null;
};

export { panelChildrenValidator };
